import 'date-format-lite'
import { getCurrentInstance } from 'vue'

const DATE_TIME_FORMATTER = 'YYYY-MM-DD hh:mm:ss'
const DATE_TIME_FORMATER = 'MM-DD hh:mm:ss'
const DATE_FORMATTER = 'YYYY-MM-DD'
const DATE_FORMATTER_CONCISE = 'MM/DD/YYYY'
const DATE_FORM_CONCISE = 'MM/DD'
const DATE_FORM_MATH = 'MM'
const TIME_FORMATTER = 'hh:mm:ss'
const TIME_FORMAHOUSE = 'hh:mm'
const TIME_FORMAMM = 'YYYY-MM'
const DATE_FORMAER = 'MM-DD'
const DATE_TIME_FORMATTE = 'MM-DD hh:mm'

const format = (time, formatter) => {
  return time ? time.date(formatter) : ''
}

export default {
  name: 'time',

  /**
   * 格式化时间
   * @param {string} time 时间
   * @param {string} formatter 格式
   * @return {string}
   */
  format(time, formatter) {
    return time ? time.date(formatter) : ''
  },

  /**
   * 年-月-日 时:分:秒
   * @param {string} time 时间
   * @return {string}
   */
  getDateTime(time) {
    return format(time, DATE_TIME_FORMATTER)
  },
  /**
   * 年-月-日 时:分:秒
   * @param {string} time 时间
   * @return {string}
   */
  getDateRYMTime(time) {
    return format(time, DATE_TIME_FORMATER)
  },
  /**
   * 月-日
   * @param {string} time 时间
   * @return {string}
   */
  getDateRYTime(time) {
    return format(time, DATE_FORMAER)
  },
  /**
   * 月-日 时:分
   * @param {string} time 时间
   * @return {string}
   */
  getDateRYSTime(time) {
    return format(time, DATE_TIME_FORMATTE)
  },
  /**
   * 年-月-日
   * @param {string} time 时间
   * @return {string}
   */
  getDate(time) {
    return format(time, DATE_FORMATTER)
  },
  /**
   * 年/月/日
   * @param {string} time 时间
   * @return {string}
   */
  getDateConcise(time) {
    return format(time, DATE_FORMATTER_CONCISE)
  },
  /**
   * 月/日
   * @param {string} time 时间
   * @return {string}
   */
  getDateDConcise(time) {
    return format(time, DATE_FORM_CONCISE)
  },
  /**
   * 月
   * @param {string} time 时间
   * @return {string}
   */
  getDateMath(time) {
    return format(time, DATE_FORM_MATH)
  },
  /**
   * 时:分:秒
   * @param {string} time 时间
   * @return {string}
   */
  getTime(time) {
    return format(time, TIME_FORMATTER)
  },

  getHouseMint(time) {
    if (time instanceof Array || !time) return ''
    return format(time, TIME_FORMAHOUSE)
  },
  /**
   * 在 time 基础上加 unit 秒、分钟...
   * @param {string} time 时间
   * @param {string} num 数量
   * @param {string} unit 单位（eg: seconds, minutes, hours, days, weeks, months, years）
   */
  add(time, num, unit) {
    time = format(time, DATE_TIME_FORMATTER)
    if (!time) return
    return new Date(time.replace(/-/g, '/')).add(num, unit)
  },
  /**
   *  比较日期相差数  默认天
   * @param startDate 开始日期 yyyy-mm-dd
   * @param endDate  截止日期 yyyy-mm-dd
   * @param unit 单位 （eg: seconds, minutes, hours, days, weeks, months, years）
   */
  difference(startDate, endDate, unit, absFlag) {
    let iDays, dateSpan
    startDate = Date.parse(startDate)
    endDate = Date.parse(endDate)
    dateSpan = endDate - startDate
    dateSpan = absFlag ? dateSpan : Math.abs(dateSpan)
    let unitNum
    switch (unit) {
      case 'months':
        break
      case 'minutes':
        unitNum = 1000 * 60
        break
      default:
        unitNum = 24 * 3600 * 1000
        break
    }
    return Math.floor(dateSpan / unitNum)
  },

  // 最近30天
  last_30Days() {
    let data = new Date()
    var time1 = format(data, 'YYYY-MM-DD') + ' 23:59:59'
    var time2 = format(data.getTime() - 30 * 24 * 60 * 60000, 'YYYY-MM-DD') + ' 00:00:00'
    return [time2, time1]
  },

  // 最近7天
  last_7Days() {
    let data = new Date()
    var time1 = format(data, 'YYYY-MM-DD') + ' 23:59:59'
    var time2 = format(data.getTime() - 7 * 24 * 60 * 60000, 'YYYY-MM-DD') + ' 00:00:00'
    return [time2, time1]
  },
  // 月份差值
  monthDifference(startDateStr, endDateStr) {
    var timestampStart = Date.parse(startDateStr)
    var timestampEnd = Date.parse(endDateStr)
    var start = new Date(timestampStart)
    var end = new Date(timestampEnd)
    // 计算年份和月份的差值
    var yearDifference = end.getFullYear() - start.getFullYear()
    var monthDifference = end.getMonth() - start.getMonth() + yearDifference * 12
    return monthDifference;
  }
}
